function scrollTop() {
    // 500 -> This is the value in px of the distance to be scrolled for the 'scroll-to-top' button to show-up
    if ($(window).scrollTop() > 500) {
      $(".backToTopBtn").addClass("active");
    } else {
      $(".backToTopBtn").removeClass("active");
    }
  }
  $(function () {
    // show and hide btn
    scrollTop();
    $(window).on("scroll", scrollTop);
  
    // body scroll on btn click
    $(".backToTopBtn").click(function () {
      $("html, body").animate({ scrollTop: 0 }, 1);
      return false;
    });
  });


  const detailsElements = document.getElementsByTagName('details');

  let search_model = document.querySelector('.search-modal__close-button');
  search_model.addEventListener('click',()=>{
    alert('click');
    // details.removeAttribute('open');
    if (detailsElements.length > 0) {
      detailsElements[0].removeAttribute('open');
  }
  })



  // Select the input field and the button
  const inputField = document.querySelector('.search__input');
  const clearButton = document.querySelector('.search-modal__close-button');

  // Add a click event listener to the button
  clearButton.addEventListener('click', () => {
      // Clear the input value
      inputField.value = '';
  });